<template>
    <div class="sel-div">
        <TitleComponent title="1. Selecciona tu asiento" subtitle="Si lo deseas, también puedes escoger varios asientos a la vez"/>
        
        <TerrenoJuegoComponent :direccion_campo="zona.direccion_campo" :tipo_recinto="zona.tipo_recinto"/>
        
        <div v-if="contextMenuVisible" class="context-menu" :style="{ top: contextMenuPosition.top + 'px', left: contextMenuPosition.left + 'px' }">
            <ul>
                <li @click="menuItemClicked">VER ABONADO</li>
            </ul>
        </div>
        <div class="container-butacas-wrapper" v-if="!loading">
            <div :class="'container-butacas text-align-' + zona.print_align">
                <span v-for="(butacas, fila) in filas" :key="fila">
                    <span class="fila">{{ fila }}</span>
                    <AsientoComponent
                        v-for="(asiento, index) in butacas"
                        :asiento="asiento" 
                        :fila="fila" 
                        :disabled="bloquearPasoDos" 
                        :key="index+'_2'" @toggle="() => toggleSeleccion(fila, asiento.asiento, true, puede_cambiar)" @menu="showContextMenu" 
                    />
                    <br />
                </span>
            </div>
        </div>
        <template v-else>
            <LoaderComponent/>
        </template>
        <div class="row align-items-center">
            <div class="col-12 col-lg-4">
                <FormInput label="Número de butacas" type="number" name="n_butacas" :max="asientos_maximos" v-model="n_butacas" />
            </div>
            <div class="col-12 col-lg-8">
                <Button :ignoreBaseClasses="true" customClass="btn btn-primary mr-2" @click="selectButacas" :disabled="n_butacas === 0 || n_butacas > asientos_maximos">Seleccionar</Button>
                <Button :ignoreBaseClasses="true" customClass="btn btn-primary" @click="selectAllButacas" :disabled="bloquearPasoDos">Seleccionar todas</Button>
                <Button :ignoreBaseClasses="true" customClass="btn btn-primary mt-2 mb-2 ml-0 mb-sm-0 mt-md-0 ml-md-2 mt-md-0 mt-lg-2 ml-lg-0 ml-xl-2 mt-xl-0" @click="clearButacas" :disabled="bloquearPasoDos">Borrar selección</Button>
            </div>
        </div>
        <ul class="leyenda-butacas list-inline">
            <li><span class="butaca libre"></span>Disponible</li>
            <li><span class="butaca ocupada"></span>Ocupado</li>
            <li><span class="butaca ocupada validado-control-acceso"></span>Validado control acceso</li>
            <li><span class="butaca seleccionada"></span>Seleccionado</li>
            <li><span class="butaca pendiente"></span>Reservada</li>
            <li><span class="butaca bloqueada"></span>Bloqueada</li>
            <li><span class="butaca bloqueada abonado"></span>Abonado</li>
        </ul>
        <div v-if="!esConfiguracionAsientosValida()" class="alert alert-warning">
            No es posible dejar butacas libres adyacentes a las butacas seleccionadas. Selecciona la butaca o las butacas y continúe con la compra.
        </div>
    </div>
</template>

<script>
    import TitleComponent from '@/components/backend/stepper/components/TitleComponent';
    import AsientoComponent from "./AsientoComponent";
    import TerrenoJuegoComponent from '../../../common/Asientos/TerrenoJuegoComponent.vue';
    import Button from '@/modules/admin/ui/Button.vue';

    export default {
        props: ['zona', 'asientos', 'asientoParaBorrar', 'puede_cambiar', 'dia_abonado', 'forzar_adyacentes', 'abono_seleccionado', 'asientos_maximos', 'continuarConAsiento', 'bloquearPasoDos'],
        data() {
            return {
                loading: true,
                filas: null,
                datos_compradores: [],
                precios: null,
                n_butacas: 0,
                contextMenuVisible: false,
                contextMenuPosition: { top: 0, left: 0 },
                asientoSelected: null
            }
        },
        computed: {
            manager() {
                return this.$store.getters.getFooter;
            }  
        },
        created() {
            if (this.continuarConAsiento) {
                this.datos_compradores = this.asientos;
            } else {
                this.datos_compradores = []
            }
            this.getZona(this.zona.id);
        },
        watch : {
            zona() {
                this.getZona(this.zona.id);
            },
            asientoParaBorrar: {
                handler(newAsiento) {
                    if (newAsiento) {
                        this.toggleSeleccion(newAsiento.fila, newAsiento.asiento, false, this.puede_cambiar);
                    }
                }
            }
        },
        methods: {
            clearButacas() {
                for (var fila in this.filas) {
                    for (var butaca in this.filas[fila]) {
                        if(this.filas[fila][butaca].seleccionado == true) {
                            this.toggleSeleccion(fila, this.filas[fila][butaca].asiento, true, true);
                        }
                    }
                }
                this.n_butacas = 0;
            },
            selectButacas() {
                var count = this.n_butacas;
                for (var fila in this.filas) {
                    for (var butaca in this.filas[fila]) {
                        if(this.filas[fila][butaca].ocupado == false && this.filas[fila][butaca].seleccionado == false && count > 0) {
                            this.toggleSeleccion(fila, this.filas[fila][butaca].asiento, true, true);
                            count--;
                        }
                    }
                }
            },
            selectAllButacas() {
                for (var fila in this.filas) {
                    for (var butaca in this.filas[fila]) {
                        if (this.filas[fila][butaca].ocupado !== true && this.filas[fila][butaca].seleccionado == false) {
                            this.toggleSeleccion(fila, this.filas[fila][butaca].asiento, true, true);
                        }
                    }
                }
            },
            getZona(id) {
                this.loading = true;
                var params = null;
                if(this.$route.params.evento_id != undefined && this.$route.params.sesion_id != undefined) {
                    params = {
                        filters: {
                            zona_id: id,
                            conf: true,
                            info: true,
                            evento_id: this.$route.params.evento_id,
                            sesion_id: this.$route.params.sesion_id
                        },
                    };
                } else {
                    params = {
                        filters: {
                            zona_id: id,
                            conf: true
                        },
                    };
                }

                this.$store.dispatch(this.config.getVuexAlias('zonas.index'), params).then(res => {
                    this.filas = res.data.configuracion_asientos;
                    this.precios = res.data.precios;

                    if(this.datos_compradores.length > 0 && this.datos_compradores[0].asiento) {
                        for(var i in this.datos_compradores) {
                            this.toggleSeleccion(this.datos_compradores[i].asiento.fila, this.datos_compradores[i].asiento.asiento ,false, true);
                        }
                    }

                    this.loading = false;
                });
            },
            toggleSeleccion : function(fila, asiento, anadir, puede_cambiar) {
                if(puede_cambiar) {
                    for(var i in this.filas[fila]) {
                        if(this.filas[fila][i].asiento == asiento && this.filas[fila][i].ocupado != 1) {
                            if(this.filas[fila][i].seleccionado) {
                                for(var j in this.datos_compradores) {
                                    if(this.datos_compradores[j].asiento.fila == fila && this.datos_compradores[j].asiento.asiento == asiento) {
                                        this.datos_compradores.splice(j, 1);                                       
                                    }
                                }
                                this.filas[fila][i].seleccionado = !this.filas[fila][i].seleccionado;
                            } else {
                                if(this.datos_compradores.length < this.asientos_maximos) {
                                    var data = {
                                        'asiento' : {
                                            fila : fila,
                                            asiento : this.filas[fila][i].asiento,
                                            zona_id : this.zona.id,
                                            zona_nombre : this.zona.name,
                                            lfp_id: this.filas[fila][i].lfp_id
                                        },

                                        nombre : '',
                                        apellidos : '',
                                        genero_id: '',
                                        dni : '',
                                        telefono : '',
                                        precios : this.precios,
                                        url_imprimir : null,
                                        es_nuevo : true,
                                        precio: null,
                                        area: this.abono_seleccionado ? this.abono_seleccionado : null
                                    };

                                    if(this.filas[fila][i].info) {
                                        data.n_abonado_antiguo = this.filas[fila][i].info.n_abonado_antiguo;
                                        data.es_nuevo = false;
                                    }


                                    if (this.puedeContinuar(this.filas[fila][i].info?.n_abonado_antiguo)) {
                                        if(anadir) {
                                            this.datos_compradores.push(data);
                                        }
    
                                        this.filas[fila][i].seleccionado = !this.filas[fila][i].seleccionado;
                                    }
                                } else {
                                    this.$toast.error('No se pueden elegir más asientos')
                                }
                            }
                        } else {
                            if(this.filas[fila][i].asiento == asiento && this.filas[fila][i].ocupado == 1) {  
                                if(this.filas[fila][i].info && this.filas[fila][i].info.tpv_order) {
                                    let url = `/admin/eventos/${this.$route.params.evento_id}/sesiones/${this.$route.params.sesion_id}/ventas?n_pedido=${this.filas[fila][i].info.tpv_order}`;
                                    window.open(url, '_blank');
                                }
                            }
                        }
                    }
                }

                this.actualizarDatos();
            },
            puedeContinuar(n_abonado_antiguo) {
                if (n_abonado_antiguo) {
                    if (this.$route.query.n_abonado_antiguo && this.$route.query.n_abonado_antiguo != n_abonado_antiguo) {
                        return false;
                    }
                }

                return true;
            },
            actualizarDatos() {
                this.$emit('actualizarDatos', this.datos_compradores, this.esConfiguracionAsientosValida());
            },
            deSeleccionarButacas() {
                for(var fila in this.filas) {
                    for(var asiento in this.filas[fila]) {
                        this.filas[fila][asiento].seleccionado = false;
                    }
                }
            },
            esConfiguracionAsientosValida() {
                if(!this.forzar_adyacentes) {
                    return true;
                }

                for(var fila in this.filas) {
                    for(var i in this.filas[fila]) {
                        if(i == 0) continue;

                        let actual = this.filas[fila][i];
                        let anterior = this.filas[fila][i-1];
                        if((actual.seleccionado && !anterior.seleccionado && !anterior.ocupado) ||
                            (anterior.seleccionado && !actual.seleccionado && !actual.ocupado)) {
                            return false;
                        }
                    }
                }

                return true;
            },
            showContextMenu(top, left, asiento) {
                if((asiento.info.es_abonado) || ((asiento.ocupado == 1 || asiento.ocupado == 2) && asiento.info.abonado_lista_abonado_id)) {
                    this.asientoSelected = asiento;
                
                    let ventaAbonos = false;

                    if (asiento.info.abonado_lista_abonado_id) { 
                        ventaAbonos = true;
                    }
                
                    this.asientoSelected.ventaAbonos = ventaAbonos;

                    this.contextMenuVisible = true;
                    this.contextMenuPosition = { top: top, left: left };

                    // Add an event listener to close the context menu when clicking outside of it
                    document.addEventListener('click', this.hideContextMenu);
                }
            },
            hideContextMenu() {
                this.contextMenuVisible = false;
                document.removeEventListener('click', this.hideContextMenu);
            },
            menuItemClicked() {
                let active_lista_id = this.$store.getters.getListaId

                if (this.asientoSelected.ventaAbonos) {
                    this.$router.push('/admin/abonados/' + active_lista_id + '/' + this.asientoSelected.info.abonado_lista_abonado_id);
                } else {
                    this.$router.push('/admin/abonados/' + active_lista_id + '/' + this.asientoSelected.info.abonado_id);
                }

                this.hideContextMenu();
            }
        },
        components: {
            AsientoComponent,
            TitleComponent,
            TerrenoJuegoComponent,
            Button
        }
    }
</script>

<style scoped>
    .col-lg-4 {
        -ms-flex: 0 0 33.333333%;
        flex: 0 0 33.333333%;
        max-width: 33.333333%;
    }

    .fila {
        font-size: 11px;
        display: inline-block;
        text-align: right;
        vertical-align: middle;
        color: #444;
        position: absolute;
        left: -20px;
        top: 50%;
        transform: translateY(-50%);
    }

    .context-menu {
        position: fixed;
        background-color: white;
        border: 1px solid #ccc;
        padding: 8px;
        box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.2);
        z-index: 1000;
    }
    .context-menu ul {
        list-style: none;
        padding: 0;
        margin: 0;
    }
    .context-menu li {
        cursor: pointer;
        padding: 4px;
    }

    @media (max-width: 768px) {
        .col-lg-4 {
            -ms-flex: 0 0 100%;
            flex: 0 0 100%;
            max-width: 100%;
            margin: 0px;
        }

        .sel-div {
            max-width: 100%;
            padding: 0px;
        }
    }
</style>
